module.exports = __webpack_public_path__ + "img/sec_img2.dde40ef8.png";